module.exports = __webpack_public_path__ + "media/images/icons/close-white-9fe882f2d2258fe7f932b6173376d939.svg";